import { ACTIONS } from './actionTypes'


export const setDownloadItemActive = id => {
  return { type: ACTIONS.SET_DOWNLOAD_ITEM_ACTIVE, id }
};



// WEBPACK FOOTER //
// ./src/redux/action/download_item_actions.js